<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <div class="h-100 d-flex justify-content-center align-items-center" v-if="isLoading">
                <vue-loaders-ball-beat scale="2" color="black" />
            </div>
            <div v-else>
                <div class="companyInfo">
                    <section>
                        <h2>Current Level Information</h2>
                        <p>
                            <strong>CUSTOMER: </strong>{{ submission.company }} ({{ submission.cust_id }})
                        </p>
                        <p>
                            <strong>PRICE LEVEL: </strong>{{ priceLevel }}
                        </p>
                        <p>
                            <strong>6M SALES: </strong>${{ submission.sales_6m }}
                        </p>
                        <p>
                            <strong>12M SALES: </strong>${{ submission.sales_12m }}
                        </p>
                    </section>
                </div>
                <br>
                <div>
                    <form @submit.prevent="savePriceLevelDeviation" method="POST">
                        <h2>
                            New Level Information<br>
                            <em id="em-stylings">Fill-out the required information below.</em>
                        </h2>
                        <div>
                            <ul id="horizontal-ul">
                                <li style="padding-left:0;width:33%;">
                                    <span style="color:#cd1b00">*</span> Requested By:<br>
                                    <admin-select v-model="requestedBy" required style="width:90%;">
                                        <option></option>
                                        <option v-for="(userId, name) in priceAuthUsers" :value="userId">{{ name }}</option>
                                    </admin-select>
                                </li>
                                <li style="width:33%;">
                                    <span style="color:#cd1b00">*</span> Suggested Level:<br>
                                    <admin-select v-model="suggestedLevel" required style="width:90%;">
                                        <option></option>
                                        <option v-for="level in filteredLevels">{{ level }}</option>
                                    </admin-select>
                                </li>
                                <li style="width:33%;">
                                    <span style="color:#cd1b00">*</span> Business Rationale:<br>
                                    <admin-select v-model="rationale" required style="width:90%;">
                                        <option></option>
                                        <option v-for="rationale in rationales">{{  rationale }}</option>
                                    </admin-select>
                                </li>
                            </ul>
                        </div>
                        <br>
                        <div>
                            <h4>Urgency</h4>
                            <input v-model="urgency" type="checkbox" value="1" />  Is this an Urgent request? If yes, check the box and provide the order number(s) below:<br />
                            <ul class="col-md-10" style="list-style-type:none; display:flex; flex-wrap:wrap; padding-left:0;">
                                <li class="col-md-3" v-for="i in 8" :key="i" style="padding-left:0;">
                                    <input
                                        type="text"
                                        :name="'ord_num['+(i-1)+']'"
                                        class="input"
                                        id="orderNumInputs"
                                        v-model="ordNum[i-1]"
                                        :placeholder="'Order #' + i"
                                    />
                                </li>
                            </ul>
                            <br />
                            Any additional details?<br />
                            <textarea v-model="additionalDetails" style="width:60%;" rows="5"></textarea>
                        </div>
                        <br />
                        <br />
                        <button class="btn-round-red" type="submit">FINISH ></button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activity: "",
                additionalDetails: null,
                i:8,
                isLoading: true,
                ordNum: ["","","","","","","",""],
                priceAuthUsers: [],
                priceLevel: "",
                pumaPriceAuths: ["520", "521", "522", "523", "524"],
                rationale: "",
                rationales: [],
                rationalesDefault: ["Competitive Conversion", "Distributor Merge/Acquisition", "End-User Conversion", "Join Buying Group", "Overall Organic Growth", "Sales Realignment"],
                rationalesPuma: ["Account Realignment", "Annual Sales Decline", "Annual Sales Growth", "Earned Price Level - Black Package Order", "Earned Price Level - New Product Order"],
                requestedBy: "",
                submission: {},
                suggestedLevel: "",
                suggestedLevelsDeviations: [],
                suggestedLevelsDeviationsStandard: ["LIST","SW5","SW10","SW15","SW20","DTR-LIST","DTR-SW5","DTR-SW10","DTR-SW15","ALLPRO"],
                suggestedLevelsDeviationsPuma: ["PUMAWHLS", "PUMA10", "PUMA5", "PUMA2.5"],
                totalSixMonthSales: "",
                totalTwelveMonthSales: "",
                urgency: null,
            }
        },
        props: ['ppId'],
        created() {
            axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
                this.submission = response.data;

                this.activityId = this.submission.activity.id;
                this.activity = this.submission.activity.activity;
                this.priceLevel = this.submission.price_level;
                this.requestedBy = this.submission.requested_by;
                this.suggestedLevel = this.submission.suggested_lvl;
                this.rationale = this.submission.rationale;
                this.urgency = this.submission.urgent;
                this.additionalDetails = this.submission.add_details;

                if(this.submission.ord_num != null) {
                    let ordNums = this.submission.ord_num.split("|");
                    this.ordNum = ordNums;
                }

                if(this.pumaPriceAuths.includes(this.submission.price_auth)) {
                    this.suggestedLevelsDeviations = this.suggestedLevelsDeviationsPuma;
                    this.rationales = this.rationalesPuma;
                } else {
                    this.suggestedLevelsDeviations = this.suggestedLevelsDeviationsStandard;
                    this.rationales = this.rationalesDefault;
                }

                this.isLoading = false;
            });
            axios.get(`/api/getPriceAuthUsers`).then(response => {
                this.priceAuthUsers = response.data;
            });
        },
        methods: {
            savePriceLevelDeviation() {
                let data = {
                    additionalDetails: this.additionalDetails,
                    id: this.submission.id,
                    ordNum: this.ordNum,
                    rationale: this.rationale,
                    requestedBy: this.requestedBy,
                    suggestedLevel: this.suggestedLevel,
                    totalSixMonthSales: this.submission.sales_6m,
                    totalTwelveMonthSales: this.submission.sales_12m,
                    urgency: this.urgency,
                }
                axios.post(`/api/savePriceLevelInformation`, data).then(response => {
                    this.$router.push({
                        name: "PriceWorkflowDashboards",
                        params: {dashboard: "LevelDeviation"}
                    });
                });
            }
        },
        computed: {
            filteredLevels() { // Will remove the current level of the cust from dropdown
                return this.suggestedLevelsDeviations.filter(level => level !== this.priceLevel);
            }
        }
    }
</script>

<style>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #em-stylings {
        font-size:.9rem; 
        font-weight:normal; 
        line-height:1.0
    }

    #horizontal-ul {
        list-style-type:none;
        display: flex;
    }

    h4 {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #orderNumInputs {
        width: 100%;
        margin-bottom:1rem;
    }

</style>
